<template>
    <div class="box">
        <div class="box_header">{{title}}</div>
    </div>

</template>

<script>
    export default {
        props: {
            title: ""
        },
        data() {
            return {
            }
        },
    }
</script>

<style scoped>
    .box_header {
        font-size: 32px;
        text-align: center;
        background-color: #096dd9;
        color: #ffffff;
        padding: 100px 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/components/title_header.vue